{
	"ariaSettings": "settings",
	"resetOnboarding": "Reset Onboarding",
	"settings": "Settings"
}
